// extracted by mini-css-extract-plugin
export default {"container":"filterbox_container__lh1Qy","filterbox":"filterbox_filterbox__DeV-X","label":"filterbox_label__N7rWS"};